const style = (theme) => ({
  root: {
    position: 'relative',
    color: theme.colors[0],
    backgroundColor: theme.colors[5],
    borderRadius: '30px',
    width: '100%',
  },
  accordionButton: {
    background: 'transparent',
    position: 'relative',
    border: 'none',
    outline: 'none',
    padding: '0px 30px',
    width: '100%',
    textAlign: 'left',
    height: '50px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  accordionTitle: {
    fontSize: 20,
    lineHeight: 1,
    margin: '0px',
    fontWeight: 'normal',
  },
  arrow: {
    padding: '0px',
    position: 'absolute',
    right: '5px',
    top: '5px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: theme.colors[1],

    '& svg': {
      width: 'calc(10px * 0.8)',
      height: 'calc(18px * 0.8)',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  accordionContent: {
    padding: '20px 30px',
    '& p': {
      fontSize: 16,
      lineHeight: 1.5,
    },
  },
  animatedWrapper: {
    overflow: 'hidden',
  },
})

export default style
